import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../apiConfig';
import styles from './PolicyPage.module.css';
import bubbleStyles from '../styles/Bubbles.module.css';

function PolicyPage() {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/contact`)
      .then(response => setContact(response.data))
      .catch(error => console.error('Error fetching contact:', error));
  }, []);

  return (
    <div>
      {/* Policy Section */}
      <div className={styles.policyContainer}>
        <h1 className={styles.policyTitle}>Policies</h1>
        <div className={styles.policyContent}>
          <ul>
            <li>🕒 Be on time. Your session cannot be extended if you are late.</li>
            <li>📱 Morning appointments need to be confirmed between 8:00 AM and 8:30 AM. Appointments at noon and after need to be confirmed at least 2 hours before the scheduled time. If PO sends no confirmation message, assume no change in schedule.</li>
            <li>🚫 Cancel responsibly. You will be blacklisted if you cancel "last-minute" 2 times within 3 months. "Last minute" cancellation is defined in the point above.</li>
            <li>📸 Do not redistribute profile images without permission.</li>
            <li>🥂 Most importantly, play nice and have fun!</li>
          </ul>
        </div>
      </div>

      {/* Contact Section */}
      <div className={styles.contactContainer}>
        <div className={styles.contactMessage}>
          Contact us for any concerns regarding quality of service, or suggestions to help us improve.
        </div>

        {contact && (
          <div className={`${bubbleStyles.bubbleStyle} ${bubbleStyles.contactWrapper}`}>
            <a href={`mailto:${contact.email}`}>{contact.email}</a>
          </div>
        )}
      </div>
    </div>
  );
}

export default PolicyPage;
